import { type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'
import { type CustomerEntity } from '@/libs/api'

import { CustomerCreateModalContent } from './CustomerCreateModalContent'

type Props = {
  open: boolean
  tenantKey: string
  onSuccess: (customer: CustomerEntity) => Promise<void>
  onClose: () => void
}

export const CustomerCreateModal: FC<Props> = ({
  open,
  tenantKey,
  onSuccess,
  onClose
}) => {
  return (
    <Modal
      title={MENU.CREATING_CUSTOMER}
      zIndex={1999}
      width={860}
      open={open}
      onCancel={onClose}
    >
      <CustomerCreateModalContent
        tenantKey={tenantKey}
        onSuccess={onSuccess}
        onCancel={onClose}
      />
    </Modal>
  )
}
